import React from 'react';
import { Image, Grid } from 'semantic-ui-react';

const AboutIntro = () => (
    <Grid>
        <Grid.Row columns={2}>
            <Grid.Column width={11}>
                <h1 className="intro-header">So you want to learn more.</h1>
                <p className="intro-content">Fair enough. Here's the TLDR: I enjoy Ping-Pong, Anime, bad reality tv, and spending time with family & friends.</p>
                <p>
                    I love to try out new tech. I'm fairly impatient and will often multi-task while working on something tedious. I'm a fan of trying out new things for the sake of experience & knowledge.
                </p>
                <p>My current favorite programming languages are Node & React (in typescript obviously).</p>
            </Grid.Column>
            <Grid.Column width={4}>
                <Image src="images/yahia_goes_kayaking.jpg" size="medium" floated="right" rounded />
            </Grid.Column>
        </Grid.Row>
    </Grid>
);

export default AboutIntro;
